import { render } from "./EventWise.vue?vue&type=template&id=490a3c3c"
import script from "./EventWise.vue?vue&type=script&lang=js"
export * from "./EventWise.vue?vue&type=script&lang=js"

import "./EventWise.vue?vue&type=style&index=0&id=490a3c3c&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__